﻿import React from 'react';
import { Sparkles } from 'lucide-react';

const UserInfoForm = ({ onSubmit, context = 'onboarding' }) => {
  const isTeam = context === 'team';
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    phone: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name.trim() && formData.email.trim()) {
      onSubmit(formData);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'linear-gradient(135deg, #2E1A47 0%, #3D265A 100%)'
    }}>
      <div className="w-full max-w-md bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 mx-auto block" style={{
          background: 'linear-gradient(135deg, #2E1A47 0%, #D4AF37 100%)'
        }}>
          <Sparkles className="w-10 h-10 text-white" />
        </div>

        {/* Title */}
        <h1 className="text-4xl font-black text-center mb-2" style={{ color: '#2E1A47' }}>
          {isTeam ? 'Add Team Member' : 'Get Started'}
        </h1>
        <p className="text-center mb-8" style={{ color: '#9A8C9D' }}>
          {isTeam ? 'Enter their details to add them to your team' : 'Enter your details to unlock your personalized career profile'}
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name Field */}
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: '#2E1A47' }}>
              Full Name *
            </label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="John Doe"
              className="w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all"
              style={{
                borderColor: '#4B3663',
                backgroundColor: '#F9F7F2'
              }}
              onFocus={(e) => e.target.style.borderColor = '#D4AF37'}
              onBlur={(e) => e.target.style.borderColor = '#4B3663'}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: '#2E1A47' }}>
              Email Address *
            </label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="john@example.com"
              className="w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all"
              style={{
                borderColor: '#4B3663',
                backgroundColor: '#F9F7F2'
              }}
              onFocus={(e) => e.target.style.borderColor = '#D4AF37'}
              onBlur={(e) => e.target.style.borderColor = '#4B3663'}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: '#2E1A47' }}>
              Phone Number (Optional)
            </label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              placeholder="+1 (555) 123-4567"
              className="w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all"
              style={{
                borderColor: '#4B3663',
                backgroundColor: '#F9F7F2'
              }}
              onFocus={(e) => e.target.style.borderColor = '#D4AF37'}
              onBlur={(e) => e.target.style.borderColor = '#4B3663'}
            />
          </div>

          {/* Privacy Notice */}
          <div className="p-4 rounded-xl" style={{ backgroundColor: '#F9F7F2' }}>
            <p className="text-sm text-center" style={{ color: '#9A8C9D' }}>
              🔒 Your information is secure and will never be shared.
            </p>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-4 rounded-xl text-white font-bold text-lg shadow-lg hover:shadow-xl transition-all hover:scale-[1.02]"
            style={{
              background: 'linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)'
            }}
          >
            Continue to Assessment →
          </button>

          {/* Footer */}
          <p className="text-sm text-center mt-4" style={{ color: '#9A8C9D' }}>
            By continuing, you agree to receive emails about your results.
          </p>
        </form>
      </div>
    </div>
  );
};

export default UserInfoForm;